import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import ItemWiseRateTab from './tabs/ItemWiseRateTab';

export const ItemRatePage = ({ showToast }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const initialItemId = searchParams.get('itemId') ? parseInt(searchParams.get('itemId'), 10) : null;
  const initialItemType = searchParams.get('itemType') ? searchParams.get('itemType').toUpperCase() : 'TEST';

  return (
    <div className="page-container fade-in">
      <div className="breadcrumb">
        <button type="button" onClick={() => navigate('/dashboard')}>
          Home
        </button>
        <span className="breadcrumb-divider">/</span>
        <button type="button" onClick={() => navigate('/masters')}>
          Masters
        </button>
        <span className="breadcrumb-divider">/</span>
        <button type="button" onClick={() => navigate(initialItemType === 'PACKAGE' ? '/masters/packages' : initialItemType === 'PROFILE' ? '/masters/profiles' : '/masters/investigations')}>
          {initialItemType === 'PACKAGE' ? 'Package Master' : initialItemType === 'PROFILE' ? 'Profile Master' : 'Investigation Master'}
        </button>
        <span className="breadcrumb-divider">/</span>
        <span className="breadcrumb-active">Item-Wise Rates</span>
      </div>

      <div className="page-header" style={{ marginBottom: '1.5rem' }}>
        <div className="page-title-group">
          <h1 className="page-title">Item-Wise Rate Configuration</h1>
          <span className="page-subtitle">
            Compare and adjust pricing for Single Tests, Clinical Profiles, and Health Packages across all registered Cash Panels.
          </span>
        </div>

        <div>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => navigate(initialItemType === 'PACKAGE' ? '/masters/packages' : initialItemType === 'PROFILE' ? '/masters/profiles' : '/masters/investigations')}
            style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}
          >
            ← Back to {initialItemType === 'PACKAGE' ? 'Package Master' : initialItemType === 'PROFILE' ? 'Profile Master' : 'Investigation Master'}
          </button>
        </div>
      </div>

      <div className="glass-card fade-in" style={{ padding: '1.5rem' }}>
        <ItemWiseRateTab showToast={showToast} initialItemId={initialItemId} initialItemType={initialItemType} />
      </div>
    </div>
  );
};

export default ItemRatePage;
